import { useMemo } from 'react';
import { buildRecurrenceRule } from './recurrenceRule';
import { RecurrenceRule, RecurrenceValues } from './types';

// Form.useWatch returns a fresh object each render, so the serialised values are the memo key
const useRecurrenceRule = (values: RecurrenceValues): RecurrenceRule => {
  const key = JSON.stringify(values ?? null);
  return useMemo(() => buildRecurrenceRule((JSON.parse(key) ?? {}) as RecurrenceValues), [key]);
};

export default useRecurrenceRule;
